import { render } from "./SecurityHome.vue?vue&type=template&id=5878dbdc&ts=true"
import script from "./SecurityHome.vue?vue&type=script&lang=ts"
export * from "./SecurityHome.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__